import * as React from "react";

const SVGComponent = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Frame">
      <path
        id="Vector"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.64535 19.9884C8.3132 21.5384 9.4948 23 11.08 23C11.6523 23 12.1843 22.7052 12.4876 22.2198L17 15H20C21.1046 15 22 14.1046 22 13V5C22 3.89543 21.1046 3 20 3H5.8541C4.71779 3 3.679 3.64201 3.17082 4.65836L1.42229 8.15542C1.14458 8.71084 1 9.32329 1 9.94427V13C1 14.6569 2.34315 16 4 16H9.5L8.64535 19.9884ZM17 4.5V13.5H20C20.2761 13.5 20.5 13.2761 20.5 13V5C20.5 4.72386 20.2761 4.5 20 4.5H17ZM11.2156 21.4248L15.5 14.5698V4.5H5.8541C5.28594 4.5 4.76655 4.821 4.51246 5.32918L2.76393 8.82624C2.59036 9.17338 2.5 9.55616 2.5 9.94427V13C2.5 13.8284 3.17157 14.5 4 14.5H9.5C9.95299 14.5 10.3817 14.7047 10.6665 15.057C10.9513 15.4093 11.0616 15.8714 10.9667 16.3143L10.1121 20.3027C9.98 20.9189 10.4498 21.5 11.08 21.5C11.1351 21.5 11.1864 21.4716 11.2156 21.4248Z"
        fill="#4E406E"
      />
    </g>
  </svg>
);
export default SVGComponent;
